// https://greensock.com/docs/v3/Installation
import { gsap } from 'gsap'
import utils from './utils';
import appUtils from './app_utils'
import throttle from 'lodash/throttle'

const POINTER = '#tip-pointer'
const POINTERPOINT = '#tip-pointer .tip-pointer__point'
let $pointerLabel = null

const onMouseMove = function(e) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/mousemove_event

  /*
  gsap.to(POINTER, 0.3, {
    css: {left: e.pageX, top: e.pageY}
  });
  */
  gsap.set(POINTER, {
    css: {left: e.clientX, top: e.clientY}
  })
}

const dataTipOut = function(e) {
  // appUtils.$body.css({cursor: ''})
  // appUtils.$body.removeClass('tip-active')
  gsap.killTweensOf(POINTER)
  gsap.to(POINTERPOINT, 0.3, {scale:1 }) // , autoAlpha:1
  $pointerLabel.text('')
}

const dataTipIn = function(e) {
  let tipStr = ''

  tipStr = $(this).attr('data-tip-in')
  /*
  const $tipContent = $(this).find('[data-tip]')
  if($tipContent.length){
    tipStr = $tipContent.html() //.clone()
  } else if ($(this).attr('data-tip-in-src')) {
    tipStr = '<img src="' + $(this).attr('data-tip-in-src') + '" />'
  } else {
    tipStr = $(this).attr('data-tip-in')
  }
  */

  if(tipStr){
    // appUtils.$body.css({cursor: 'none'})
    // appUtils.$body.addClass('tip-active')
    // $(POINTER).html(tipStr)
    $pointerLabel.text(tipStr)
    gsap.killTweensOf(POINTER)
    gsap.to(POINTERPOINT, 0.3, {scale:10 }) // , autoAlpha:1
  } else {
    dataTipOut(e)
  }
}

const dataTipHide = function(e) {
  $(POINTER).css('display', 'none')
}

const dataTipShow = function(e) {
  $(POINTER).css('display', 'block')
}

const windowScroll = function() {
  // Windows update cursor on scroll? Not working
  // appUtils.$document.trigger('mouseenter')
  // appUtils.$document.trigger('mouseleave')
}
const windowScrollThrottle = throttle(windowScroll, 200)

const appInit = function() {
  $pointerLabel = $('#tip-pointer .tip-pointer__label')

  if(appUtils.isTouch()){

  } else {

    // appUtils.$body.append('<div id="tip-pointer"></div>')
    // appUtils.$body.css({cursor: 'none'})
    appUtils.$body.addClass('tip-active')

    appUtils.$document.on('mousemove', onMouseMove)
    appUtils.$document.on('mouseenter', '[data-tip-in]', dataTipIn) //mouseover
    appUtils.$document.on('mouseleave', '[data-tip-out]', dataTipOut) //mouseOut

    appUtils.$document.on('mouseenter', '[data-tip-hide]', dataTipHide) //mouseover
    appUtils.$document.on('mouseleave', '[data-tip-hide]', dataTipShow) //mouseOut

    appUtils.$window.on('app:page_init', dataTipOut)
    // appUtils.$window.on('scroll', windowScrollThrottle)
  }
}

const appDestroy = function() {
  if(appUtils.isTouch()){

  } else {
    // appUtils.$body.css({cursor: ''})
    appUtils.$body.removeClass('tip-active')

    appUtils.$document.off('mousemove', onMouseMove)
    appUtils.$document.off('mouseenter', '[data-tip-in]', dataTipIn) //mouseover
    appUtils.$document.off('mouseleave', '[data-tip-out]', dataTipOut) //mouseOut

    appUtils.$document.off('mouseenter', '[data-tip-hide]', dataTipHide) //mouseover
    appUtils.$document.off('mouseleave', '[data-tip-hide]', dataTipShow) //mouseOut

    appUtils.$window.off('app:page_init', dataTipOut)
    // appUtils.$window.off('scroll', windowScrollThrottle)
  }
}

export default {appInit, appDestroy}
